/**
 * Whether the current user may WRITE a scenario.
 *
 * Advisors/admins can open a client's scenario (RLS allows the read) but
 * their writes are silently rejected by RLS — the UI must not attempt them.
 * A scenario with no owner yet (never saved) is editable by whoever is
 * building it, signed in or not; a scenario with an owner requires a match.
 */
export function canEditScenario(
  currentUserId: string | null | undefined,
  ownerUserId: string | null | undefined,
): boolean {
  if (ownerUserId == null) return true;
  return currentUserId === ownerUserId;
}
